import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Observable} from "rxjs";
import {HttpService} from "../../_service/http.service";
import {isNullOrUndefined} from "util";
import {isEmpty} from "rxjs/operator/isEmpty";
/**
 * Created by K.Lapihin on 09.01.2018.
 */
@Component({
  selector: 'app-address-searcher',
  template: `<input min-chars="1" class="form-control form-control-grey" ngui-auto-complete
                    [(ngModel)]="localSelectedItem" #item (ngModelChange)="onChange(item.value)"
                    placeholder="Начните ввод" no-match-found-text="адрес не найден" loading-text="Загрузка"
                    id="streets"
                    [source]="observableSource" [value-formatter]="myValueFormatter"
                    [list-formatter]="myListFormatter"
                    autofocus/>`
})
export class AddressSearcherComponent implements OnInit {

  @Output()
  public selectedItem: EventEmitter<any> = new EventEmitter<any>();

  localSelectedItem: any;

  addressesList: Observable<any[]>;

  @Input()
  public alias: any;

  constructor(private httpService: HttpService) {
  }

  ngOnInit(): void {
  }

  observableSource = (keyword: any): Observable<any[]> => {
    if (keyword) {
      const sb = [];
      sb.push('rest/getSuitableAddress?');
      sb.push('&searchString=');
      sb.push(keyword);
      sb.push('&organizationAlias=' + this.alias);
      const listOb = this.httpService.getRawData(sb.join(''));
      this.addressesList = listOb;
      return listOb;
    } else {
      return Observable.of([]);
    }
  }

  onChange(event: any) {

    // console.log(this.localSelectedItem);
    // this.selectedItem.emit(this.localSelectedItem);
    // console.log(this.selectedItem);

    if (this.localSelectedItem === '' || isNullOrUndefined(this.localSelectedItem)) {
      this.selectedItem.emit({
        data: null
      });
      return;
    }

    if (typeof this.localSelectedItem === 'string' && !isNullOrUndefined(this.addressesList)) {
      this.addressesList.subscribe((items: any[]) => {
        let item = items.find(p => {
          return (p.fullStreetName === this.localSelectedItem);
        });

        if (!isNullOrUndefined(item)) {
          this.localSelectedItem = item;
        }

        this.selectedItem.emit({
          data: this.localSelectedItem
        });
        console.log(this.localSelectedItem);
      });
    } else {
      this.selectedItem.emit({
        data: this.localSelectedItem
      });
      console.log(this.localSelectedItem);
    }
  }

  myListFormatter(data: any): string {
    return data.fullStreetName + (data.typeString != null && data.typeString !== '' ? ' (' + data.typeString + ')' : '');
  }

  myValueFormatter(data: any): string {
    // return data.fullStreetName + (data.typeString != null && data.typeString !== '' ? ' (' + data.typeString + ')' : '');
    return data.fullStreetName;
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_commonComp/address-searcher/address-searcher.component.ts